import moment from "moment";
import React, { useEffect } from "react";
import ReusableModal from "../../components/Modals/ReusableModal";
import Loading from "../../components/Loading";
import { DropArea } from "../LongitudinalSchedules/components/DropArea";
import { Icon } from "@virtuslab/tetrisly-icons";
import AppointmentLockModal from "../LongitudinalSchedules/components/AppointmentLockModal";
import AppointmentStatusModal from "../LongitudinalSchedules/components/AppointmentStatusModal";
import CloseSvg from "../../assets/svgs/CloseSvg";
import AppointmentCard from "./components/AppointmentCard";
import { selectUser } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";

const PatientSchedulingModal = ({
  providerAppointment,
  selectedDate,
  openProviderAppointments,
  setOpenProviderAppointments,
  setCreateAppointment,
  updatedAppointments,
  setUpdatedAppointments,
  setOpenMap,
  setIsPublished,
  createLoad,
  setOpenConfirmModal,
  view,
  handleSubmit,
}) => {
  const user = useSelector(selectUser);

  const [openStatusModal, setOpenStatusModal] = React.useState(false);
  const [appointmentToChangeStatus, setAppointmentToChangeStatus] =
    React.useState(null);
  const [openLockModal, setOpenLockModal] = React.useState(false);
  const [appointmentToLock, setAppointmentToLock] = React.useState(null);

  const [editable, setEditable] = React.useState(false);
  const [draggingAppointment, setDraggingAppointment] = React.useState(null);

  const onDrop = async (index) => {
    if (draggingAppointment === null) return;
    // getClosestDistance(appointments, index + 1);
  };

  const handleLockModal = () => {
    if (openLockModal) setAppointmentToLock(null);
    setOpenLockModal(!openLockModal);
  };

  const handleStatusModal = () => {
    if (openStatusModal) setAppointmentToChangeStatus(null);
    setOpenStatusModal(!openStatusModal);
  };

  const handleLock = async () => {
    try {
      const status =
        appointmentToLock.status === "LOCKED" ? "UNLOCKED" : "LOCKED";
      setCreateAppointment((prev) => ({ ...prev, status }));
      setUpdatedAppointments((prev) =>
        prev.map((p) => (p.proposedPatient ? { ...p, status } : p))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeStatus = async (status) => {
    try {
      setCreateAppointment((prev) => ({ ...prev, visitStatus: status }));
      setUpdatedAppointments((prev) =>
        prev.map((p) => (p.proposedPatient ? { ...p, visitStatus: status } : p))
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (updatedAppointments.length === 1) {
      setUpdatedAppointments(updatedAppointments.map((appointment) => ({
        ...appointment,
        timeslot: providerAppointment?.proposedTimeslot
      })));

      setCreateAppointment((prev) => ({ ...prev, timeslot: providerAppointment?.proposedTimeslot }));
    }
  }, [updatedAppointments]);

  return (
    <ReusableModal open={openProviderAppointments} hideHeader>
      <div className="w-[700px] h-full bg-white overflow-hidden absolute right-0 top-0">
        <Loading loading={createLoad} />
        <div className="flex flex-col gap-2 p-3">
          <div className="flex gap-4 justify-between items-center">
            <p className="m-0 text-2xl font-bold">
              {providerAppointment?.name}
            </p>
            <button onClick={() => setOpenProviderAppointments(false)}>
              <CloseSvg />
            </button>
          </div>
          <span className="text-md text-primarytextgrey">
            {view === "list"
              ? moment(providerAppointment?.date).format("dddd MMMM DD, YYYY")
              : moment(selectedDate).format("dddd MMMM DD, YYYY")}
          </span>
          <div className="flex gap-4 justify-between items-center">
            <p className="m-0 font-bold text-md">
              {Math.trunc(
                Number(providerAppointment?.originalDistance)?.toFixed(0) ?? 0
              )}{" "}
              miles |{" "}
              {updatedAppointments.length > 1 ? Math.trunc(
                Number(
                  providerAppointment?.proposedDistance -
                  providerAppointment?.originalDistance
                )?.toFixed(0) ?? 0
              ) : Math.trunc(
                Number(
                  providerAppointment?.proposedDistance -
                  providerAppointment?.originalDistance
                )?.toFixed(0) ?? 0
              ) / 2}{" "}
              miles added to route
            </p>
            <button onClick={() => setOpenMap(true)} disabled={!user?.permissions?.includes('dispatch.view_map_dispatch')}>
              <div className="flex gap-2 items-center p-2 rounded-md bg-primaryblue">
                <Icon name="20-map" color="#fff" />
              </div>
            </button>
          </div>
        </div>
        <div className="w-full h-[1px] bg-gray-200" />
        {/* {updatedAppointments.length > 0 && (
          <div className="flex justify-end px-4 py-2">
            <button
              disabled={true}
              onClick={() => {
                setEditable(!editable);
              }}
              className="flex justify-center items-center w-10 h-10 rounded-md transition-all duration-200 ease-in-out bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {!editable ? (
                <Tooltip title="Edit appointment sequence">
                  <img
                    src={Edit_Icon}
                    alt="edit"
                    className="object-contain w-5 h-5"
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Save">
                  <CheckSvg color={"#0d6efd"} />
                </Tooltip>
              )}
            </button>
          </div>
        )} */}
        <div className="flex flex-col w-full gap-2 px-4  h-[calc(100vh-200px)] overflow-x-hidden overflow-y-auto">
          <DropArea onDrop={() => onDrop(0)} />
          {updatedAppointments.map((appointment, index) => (
            <>
              <AppointmentCard
                appointment={{ ...appointment, distanceFromHome: updatedAppointments.length > 1 ? appointment.distanceFromHome : appointment.distanceFromHome / 2, durationFromHome: updatedAppointments.length > 1 ? appointment.durationFromHome : appointment.durationFromHome / 2 }}
                index={index}
                editable={editable}
                handleStatusModal={handleStatusModal}
                handleLockModal={handleLockModal}
                setAppointmentToChangeStatus={setAppointmentToChangeStatus}
                setAppointmentToLock={setAppointmentToLock}
                updatedAppointments={updatedAppointments}
              />
              <DropArea onDrop={() => onDrop(index + 1)} />
            </>
          ))}
        </div>
        <div className="w-full h-[1px] bg-gray-200" />
        {updatedAppointments.length > 0 && (
          <div className="flex gap-4 justify-center items-center p-2 bg-white border-t">
            {user?.permissions?.includes('dispatch.publish_to_ehr_dispatch') && (
              <button
                onClick={() => {
                  setOpenConfirmModal(true);
                  setIsPublished(true);
                  handleSubmit();
                }}
                className="py-2 px-4 font-bold border-[1px] shadow-sm rounded-md text-primarytextgreen border-primarytextgreen"
              >
                Publish to Athena
              </button>
            )}
            <button
              onClick={() => {
                setOpenConfirmModal(true);
                handleSubmit();
              }}
              className="py-2 px-4 font-bold border-[1px] shadow-sm rounded-md text-primarytextgreen border-primarytextgreen"
            >
              Add to Schedule
            </button>
          </div>
        )}
      </div>

      <AppointmentLockModal
        open={openLockModal}
        handleLockModal={handleLockModal}
        handleLock={handleLock}
        status={appointmentToLock?.status}
      />
      {appointmentToChangeStatus && (
        <AppointmentStatusModal
          open={openStatusModal}
          handleCancel={handleStatusModal}
          handleSubmit={handleChangeStatus}
          status={appointmentToChangeStatus?.visitStatus}
        />
      )}
    </ReusableModal>
  );
};

export default PatientSchedulingModal;
